export default __webpack_public_path__ + "static/media/nearby.032d5bb3.svg";